import React, { useCallback, useEffect, useState } from "react";
import { useAuth } from "contexts/auth";
import NavGroup from "./NavGroup";
import NavLink from "./NavLink";
import { MenuChildrenType, MenuType } from "contexts/TabsMenuContext/types";

interface NavItemsProps {
  verticalNavItems: MenuType[] | MenuChildrenType[];
  searchedValue?: string;
  flatMenuItems: MenuChildrenType[];
}

const NavItems: React.FC<NavItemsProps> = (props) => {
  const { verticalNavItems, searchedValue, flatMenuItems } = props;
  const [searchedMenuItems, setSearchedMenuItems] = useState<
    MenuChildrenType[]
  >([]);
  const { user } = useAuth();

  const hasAccessToOneOfChildren = useCallback(
    (menu: MenuChildrenType[]) => {
      // if (
      //   user &&
      //   !user?.isAdmin &&
      //   menu.every(
      //     (menuChild) => !user?.accessiblePages?.includes(menuChild.accessLabel)
      //   )
      // ) {
      //   return false;
      // }
      // return true;
      return true;
    },
    [user]
  );

  const resolveNavItemComponent = useCallback(
    (item: MenuType | MenuChildrenType) => {
      if (item.children && hasAccessToOneOfChildren(item.children)) {
        return NavGroup;
      }
      return item.children ? React.Fragment : NavLink;
    },
    [hasAccessToOneOfChildren]
  );

  useEffect(() => {
    if (flatMenuItems) {
      const items = flatMenuItems.filter((item) =>
        item.title.includes(searchedValue || "")
      );
      setSearchedMenuItems(items);
    }
  }, [flatMenuItems, searchedValue]);

  const renderNavItems = (items: MenuType[] | MenuChildrenType[]) =>
    items.map((item, index) => {
      const TagName: any = resolveNavItemComponent(item);
      return <TagName {...props} key={index} item={item} />;
    });

  return (
    <>
      {searchedValue && searchedValue.length > 0
        ? renderNavItems(searchedMenuItems)
        : renderNavItems(verticalNavItems)}
    </>
  );
};

export default NavItems;
